import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import * as Icons from '@tabler/icons-react';

const NavigationItemIcon = ({ item, isActive, onClick }) => {
  const navigate = useNavigate();
  const IconComponent = item.icon || Icons.IconFolder;
  const Element = item.external ? 'a' : 'button';

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <Element
      {...(item.external ? {
        href: item.path,
        target: '_blank',
        rel: 'noopener noreferrer'
      } : { type: 'button' })}
      onClick={item.external ? undefined : handleClick}
      className={`
        w-full p-3
        flex items-center justify-center
        ${isActive
          ? 'text-accent'
          : 'text-text-tertiary hover:bg-surface-3 hover:text-text-secondary'
        }
      `}
      style={isActive ? { background: 'var(--accent-muted)' } : {}}
      title={item.label}
      aria-label={item.label}
    >
      <IconComponent size={24} />
    </Element>
  );
};

NavigationItemIcon.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.elementType,
    path: PropTypes.string,
    label: PropTypes.string.isRequired,
    external: PropTypes.bool
  }).isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};

export default React.memo(NavigationItemIcon);
